module.exports = __webpack_public_path__ + "static/media/concept2.ec97898a.svg";